import React, { useState, useEffect } from "react";
import { Row, Col, Card, Table, Badge } from "react-bootstrap";

const Rapoarte = () => {
  const [comenzi, setComenzi] = useState([]);

  useEffect(() => {
    fetch("/comenzi")
      .then((r) => r.json())
      .then(setComenzi);
  }, []);

  const nrDoc = (c) => {
    let nr = 0;
    if (c.factura?.numar) nr++;
    if (c.uit?.cod) nr++;
    if (c.cmr?.numar) nr++;
    if (c.declaratie?.semnat === "da") nr++;
    return nr;
  };

  // 1. Total valoare pe tara
  const valoarePeTara = comenzi.reduce((acc, c) => {
    const tara = c.tara || "Necunoscut";
    acc[tara] = (acc[tara] || 0) + parseFloat(c.valoare || 0);
    return acc;
  }, {});

  // 2. Comenzi fara dosar complet
  const dosareIncomplete = comenzi.filter((c) => nrDoc(c) < 4);

  // 3. Valoare pe luna
  const valoarePeLuna = comenzi.reduce((acc, c) => {
    if (!c.data_comanda) return acc;
    const luna = c.data_comanda.substring(0, 7); // "2026-05"
    acc[luna] = (acc[luna] || 0) + parseFloat(c.valoare || 0);
    return acc;
  }, {});
  const luniSortate = Object.keys(valoarePeLuna).sort().reverse();

  return (
    <>
      <h2 className="mb-4">Rapoarte</h2>

      <Row>
        {/* Valoare pe tara */}
        <Col md={6} className="mb-4">
          <Card>
            <Card.Header className="bg-primary text-white">
              <strong>Valoare exporturi pe țară (EUR)</strong>
            </Card.Header>
            <Card.Body>
              <Table striped bordered size="sm">
                <thead>
                  <tr>
                    <th>Țară</th>
                    <th className="text-end">Valoare EUR</th>
                  </tr>
                </thead>
                <tbody>
                  {Object.entries(valoarePeTara)
                    .sort((a, b) => b[1] - a[1])
                    .map(([tara, val]) => (
                      <tr key={tara}>
                        <td>{tara}</td>
                        <td className="text-end">
                          {val.toLocaleString("ro-RO")} EUR
                        </td>
                      </tr>
                    ))}
                </tbody>
              </Table>
            </Card.Body>
          </Card>
        </Col>

        {/* Valoare pe luna */}
        <Col md={6} className="mb-4">
          <Card>
            <Card.Header className="bg-success text-white">
              <strong>Valoare exporturi pe lună (EUR)</strong>
            </Card.Header>
            <Card.Body>
              <Table striped bordered size="sm">
                <thead>
                  <tr>
                    <th>Lună</th>
                    <th className="text-end">Valoare EUR</th>
                  </tr>
                </thead>
                <tbody>
                  {luniSortate.map((luna) => (
                    <tr key={luna}>
                      <td>{luna}</td>
                      <td className="text-end">
                        {valoarePeLuna[luna].toLocaleString("ro-RO")} EUR
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </Card.Body>
          </Card>
        </Col>

        {/* Dosare incomplete */}
        <Col md={12} className="mb-4">
          <Card>
            <Card.Header className="bg-danger text-white">
              <strong>
                Comenzi cu dosar incomplet — TVA 0% la risc (
                {dosareIncomplete.length})
              </strong>
            </Card.Header>
            <Card.Body>
              {dosareIncomplete.length === 0 ? (
                <p className="text-success mb-0">
                  Toate dosarele sunt complete!
                </p>
              ) : (
                <Table striped bordered size="sm">
                  <thead>
                    <tr>
                      <th>Client</th>
                      <th>Țară</th>
                      <th>Valoare EUR</th>
                      <th>Data</th>
                      <th>Dosar</th>
                    </tr>
                  </thead>
                  <tbody>
                    {dosareIncomplete.map((c) => (
                      <tr key={c.id}>
                        <td>{c.client}</td>
                        <td>{c.tara}</td>
                        <td>
                          {parseFloat(c.valoare).toLocaleString("ro-RO")} EUR
                        </td>
                        <td>{c.data_comanda}</td>
                        <td>
                          <Badge bg="warning" text="dark">
                            {nrDoc(c)}/4
                          </Badge>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default Rapoarte;
